import { z } from "zod";

const hexColorValidator = z
  .string()
  .refine(
    (color) => /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(color),
    {
      message: "Only accepts valid hex color codes (e.g., #abc or #abcdef)",
    }
  );
// const uriFriendlyRegex = /^[a-zA-Z0-9-_]+$/;

export const clientOnboardingSchema = z.object({
  step1: z.object({
    appTemplateId: z.string().min(3, "Please select an app"),
    appTemplateName: z.string().optional(),
    requiredTemplateModalTypes: z.array(z.string()).optional(),
    appName: z.string().min(3, "Please select an app"),
  }),
  step2: z.object({
    appName: z
      .string()
      .min(3, "App name must be at least 3 characters long")
      .max(30, "App name must be less than 25 characters"),
    // .regex(uriFriendlyRegex, {
    //   message:
    //     "app_url_name should only contain URI-friendly characters (alphanumeric, '-', '_', and '.')",
    // }),
    slug:z.string().min(3,'App slug is required'),
    appUrl: z.string().url(),
    description: z
      .string()
      .max(255, "Description must be less than 255 characters")
      .optional(),
    ai_models: z.array(z.string()).min(1, "Ai Model is required"),
    text_to_text_modal: z.string().optional(),
    text_to_image_modal: z.string().optional(),
    is_paid: z.boolean().default(false),
  }),
  step3: z.object({
    blogTitle: z
      .string()
      .min(3, "Blog title must be at least 3 characters long")
      .max(100, "Blog title must be less than 100 characters"),
    blogContent: z
      .string()
      .min(3, "Blog content must be at least 3 characters long"),
  }),
  step4: z.object({
    primaryColor: hexColorValidator,
      backgroundColor: hexColorValidator,
    appearance: z.enum(["light", "dark"]).default("light"),
    logo: z
      .string()
      .optional(),
    headerFont: z.string(),
    bodyFont: z.string(),
  }),
});
export type clientOnboardingType = z.infer<typeof clientOnboardingSchema>;
